import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCartId, getCartPrices, getShippingMethods as getShippingMethodsSelector, } from '@yme/common/redux/cart/selectors';
import { getShippingMethods } from '@yme/common/redux/cart/services';
import { useTranslation } from '@yme/services/i18n';
import { colorAccentSuccess700Base, colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { formatPrice } from '@yme/utils/formatPrice';
import { getShippingLabel } from './helpers';
import { OrderPriceStyled } from './styled';
export const OrderSummaryPrice = ({ rootLanguage }) => {
    const dispatch = useDispatch();
    const cartDataId = useSelector(getCartId);
    const shippingMethods = useSelector(getShippingMethodsSelector);
    const { totalPrice, subtotalPrice, totalDiscount } = useSelector(getCartPrices);
    const { t } = useTranslation();
    const totalPriceValue = (subtotalPrice?.amount || 0) - (totalDiscount?.amount || 0);
    const shippingLabel = useMemo(() => getShippingLabel({
        shippingMethods,
        freeShippingLabel: t('shoppingCart_freeShipping_label'),
        freeShippingAboveLabel: t('shoppingCart_freeShippingAbove_label'),
        totalPriceValue,
    }), [shippingMethods, t, totalPriceValue]);
    const isFreeShipping = useMemo(() => shippingLabel === t('shoppingCart_freeShipping_label'), [shippingLabel, t]);
    useEffect(() => {
        if (cartDataId) {
            (async () => {
                await dispatch(getShippingMethods());
            })();
        }
    }, [dispatch, cartDataId]);
    return (React.createElement(FlexWrapper, { isFullWidth: true, justifyContent: "space-between", alignItems: "center", gap: "16px" },
        React.createElement(FlexWrapper, { flexDirection: "column", alignItems: "flex-start" },
            React.createElement(RegularTextLevel3, null, t('shoppingCart_orderSubtotal_label')),
            shippingLabel && (React.createElement(RegularTextLevel4, { color: isFreeShipping ? colorAccentSuccess700Base : colorCoreBlack300 }, shippingLabel))),
        React.createElement(OrderPriceStyled, null, formatPrice({
            locale: rootLanguage,
            currencyName: totalPrice?.currencyCode,
            price: totalPriceValue,
        }))));
};
